import { FormControl, FormControlLabel, Switch } from '@mui/material';
import {
  CUSTOMER_FILTERS_TABLE_STATE_KEY,
  ICustomerFilterState,
  getLocalStoredCustomerFiltersState,
} from 'customer-management/state/customerFilterState';
import { FilterProps } from 'react-table';
import { useLocalStorage } from 'shared/hooks';
import { CustomerManagementGridItem } from 'shared/types';

export function ShowDeletedFilter({ column: { setFilter, id } }: FilterProps<CustomerManagementGridItem>) {
  const labelSwitch = { inputProps: { 'aria-label': 'Delete switch' } };
  const [localStorageValue, setLocalStorageValue] = useLocalStorage<ICustomerFilterState>(
    CUSTOMER_FILTERS_TABLE_STATE_KEY,
    getLocalStoredCustomerFiltersState()
  );
  const defaultValue = localStorageValue.filters?.find(f => f.id === id)?.value || false;

  return (
    <FormControl fullWidth>
      <FormControlLabel
        sx={{ padding: '10px' }}
        control={
          <Switch
            {...labelSwitch}
            defaultChecked={defaultValue}
            onClick={() => {
              const storedValue = getLocalStoredCustomerFiltersState();
              if (storedValue.filters) {
                if (storedValue.filters.some(f => f.id === id)) {
                  if (storedValue.filters.filter(f => f.id === id)[0].value) {
                    storedValue.filters.filter(f => f.id === id)[0].value = false;
                  } else {
                    storedValue.filters.filter(f => f.id === id)[0].value = true;
                  }
                  setLocalStorageValue({
                    filters: [...storedValue.filters],
                  });
                } else {
                  setLocalStorageValue({
                    filters: [...storedValue.filters, { id, value: false }],
                  });
                }
                let filterValue: boolean | undefined = false;
                if (storedValue.filters.find(f => f.id === id)?.value) {
                  filterValue = undefined;
                }
                setFilter(filterValue);
              } else {
                setLocalStorageValue({
                  filters: [{ id, value: true }],
                });
                setFilter(undefined);
              }
            }}
          />
        }
        label='Show deleted'
      />
    </FormControl>
  );
}
